import React,{lazy} from "react";
import {Outlet} from "react-router-dom";
import {SiteLoader} from "../components/elements/loaders";
const Dashboarer=lazy(()=>import("./dashboarder"))
const Site=lazy(()=>import("./site"))
export const SiteLayout=(props)=>{
    return(
        <React.Suspense fallback={<SiteLoader/>}>
        <Site>
            <Outlet {...props}/>
        </Site>
        </React.Suspense>
    )
}
export const DashboarerLayout=(props)=>{
    return(
        <React.Suspense fallback={<SiteLoader/>}>
        <Dashboarer>
            <Outlet {...props}/>
        </Dashboarer>
        </React.Suspense>
    )
}